import React from "react";
import "./App.css";
import Main from "../Features/Main";

function App() {
  return <Main />;
}

export default App;
